import axios from "axios";
import firebase from "../../firebaseConfig";
// import fb from "firebase/compat/app";

const newTextPostStore = {
    namespaced: true,
    state: () => ({
        newTextPostStep: {
            MEDIA_SELECTION: 1, // THIS STEP MUST ALWAYS COMES BEFORE CONTENT_CREATION
            CONTENT_CREATION: 2,
            CONTENT_METADATA: 3,
        },
        mediaSelectionStep: {
            complete: false,
            manualTextInputSelected: false,
            textFileUploadSelected: false,
        },
        contentCreationStep: {
            complete: false,
        },
        contentMetadataStep: {
            completed: false,
        },
        postAnalytics: { // ***UPDATE THESE VALUES BEFORE FINAL PUSH - SCOT BRADY AUGUST 18, 2024***
            startTimes: [], // a user may start it, save it as a draft, then restart it.
            endTimes: [],
            pushToTawq: true, // should always be pushToTawq in this creation style
            // pickUpToTawq: null,
            isMobileDevice: null,
            isIOS: null,
            totalAudioTime: 0,
            stepOrder: {}, // might not need this
            postType: null, // either 'public' or 'group'
            // dualDevice: null, 
            total_contributions: 0,
        },
        textPost: {
            currentStep: 1,
            textAdded: [],
            title: "",
            description: "",
            thumbnail: null,
            randomThumbnailNumber: 0,
            group: "",
            groupLanguage: null,
            tags: [],
            type: null, // postType: null, // either 'public' or 'group'
            file: {},
            fileTextSeparationType: null, // default type is '  (Space)' (space - word separation) // types are: | ' (Space)' (space - for word separation) | ', (Comma)' (comma - for csv files separation) | '; (Semicolon)' (semicolon - for certain files? separation) | '/  (Forward Slash)' (forward slash - for csv files and certain other files? separation) | '\n (New Line Character)' (new line character - for new line separation) | '. (Period)' (period - for sentence separation)
            userId: "",
            username: "",
            userProfilePhoto: "",
            postId: "",
            audioDataId: "",
            // category: null,
            languageSelected: {
                text: "English (United States)",
                value: "en-US",
                model: 0,
                location: 0,
                recognizerEnum: 0,
                recognizer: "gl-en-us-en-in-en-gb",
            },
            noCaptionLanguageSelected: "",
            textAddedLanguageSelected: {
                text: "English",
                value: "en",
            },
        },
        tawqData: {}, // tawqData will have keys that are audioSegId's. each key will be an object containing 3 arrays - videoSegArray, audio, caption
        postMetaDataUploadComplete: false, // the whole post has been completely uploaded
        audioCaptionsUploadComplete: false, // set to true when audio, captions and text data have been uploaded
        uploading_text: false, // set true during the upload process
        resumable_progress: 0, // the progress for the video file being uploaded to storage
        isPublicPost: false,
        fbUser: firebase.auth.currentUser,
        processTextAttempts: 0,
    }),
    mutations: {
        saveFirebaseUser (state) {
            state.textPost.userId = firebase.auth.currentUser.uid;
            state.textPost.username = firebase.auth.currentUser.displayName;
            state.textPost.userProfilePhoto = firebase.auth.currentUser.photoURL;
            state.fbUser = firebase.auth.currentUser;
        },
        saveTextPostLanguageSelected (state, payload) {
            state.textPost.languageSelected.text = payload.text;
            state.textPost.languageSelected.value = payload.value;
            state.textPost.languageSelected.model = payload.model;
            state.textPost.languageSelected.location = payload.location;
            state.textPost.languageSelected.recognizerEnum = payload.recognizerEnum;
            state.textPost.languageSelected.recognizer = payload.recognizer;
        },
        saveTextPostTextAddedLanguageSelected (state, payload) {
            state.textPost.textAddedLanguageSelected.text = payload.text;
            state.textPost.textAddedLanguageSelected.value = payload.value;
        },
        saveIsPostPublic (state, isPublic) {
            state.isPublicPost = isPublic;
        },
        saveResumableProgress (state, progress) {
            state.resumable_progress = progress;
        },
        saveTextPostCurrentStep (state, payload) {
            state.textPost.currentStep = payload;
        },
        saveMediaSelectionStep (state, payload) {
            state.mediaSelectionStep = Object.assign(state.mediaSelectionStep, payload);
            // state.mediaSelectionStep.complete = payload;
        },
        saveMediaSelectionType (state, payload) {
            state.textPost.type = payload;
        },
        saveContentMetadataStep (state, payload) {
            state.contentMetadataStep = payload;
        },
        saveContentCreationStep (state, payload) {
            state.contentCreationStep = payload;
        },
        saveTawqData (state, payload) {
            // console.log("the payload in saveTawqData: ", payload);
            // state.tawqData = Object.assign({}, state.tawqData, { [payload.key]: payload.value } );
            state.tawqData = Object.assign({}, state.tawqData, payload );
        },
        deleteKeyFromTawqData (state, payload) {
            // console.log("payload key: ", payload.key);
            delete state.tawqData[payload.key];
        },
        saveTextPost (state, payload) {
            state.textPost = Object.assign(state.textPost, payload);
        },
        saveTextAdded (state, data) {
            state.textAdded = data;
        },
        resetStoreState (state) {
            state.postMetaDataUploadComplete = false;
            state.audioCaptionsUploadComplete = false;
            state.textFileUploadComplete = false;
            state.uploading_text = false;
            state.resumable_progress = 0;
            state.isPublicPost = false;
            state.fbUser = firebase.auth.currentUser;
            state.textPost = {
                currentStep: 1,
                textAdded:[],
                title: "",
                description: "",
                thumbnail: null,
                randomThumbnailNumber: 0,
                group: "",
                groupLanguage: null,
                tags: [],
                type: null, // postType: null, // either 'public' or 'group'
                userId: "",
                username: "",
                userProfilePhoto: "",
                postId: "",
                audioDataId: "",
                // category: null,
                languageSelected: {
                    text: "English (United States)",
                    value: "en-US",
                    model: 0,
                    location: 0,
                    recognizerEnum: 0,
                    recognizer: "gl-en-us-en-in-en-gb",
                },
                noCaptionLanguageSelected: "",
                textAddedLanguageSelected: {
                    text: "English",
                    value: "en",
                },
            };
            state.tawqData = {};
            state.processTextAttempts = 0;
        }
    },
    actions: {
        setMediaSelectionStep ({commit}, payload) {
            commit('saveMediaSelectionStep', payload);
        },
        setFirebaseUser ({commit}, user) {
            commit('saveFirebaseUser', user);
        },
        setPostAudience ({commit}, isPublic) {
            commit('saveIsPostPublic', isPublic);
        },
        async saveCreatedTextPost ({state, /*commit,*/ dispatch}, payload) {
            state.uploading_text = true;
            state.textPost = payload.post;
            // console.log("state.textPost: ", state.textPost);

            const simulateProgressPayload = {
                progress: state.resumable_progress,
                interval: 500,
            };
            await dispatch("simulateProgress", simulateProgressPayload); // update to show user that upload is complete

            state.textFileUploadComplete = true;
            // state.processing_text = true;
            // commit('saveResumableProgress', 100);

            let audioDataIds = [];
            audioDataIds.push(state.textPost.audioDataId);

            // dispatch('setTextData');
            // let imageUrl = await dispatch('uploadTextThumbnail');
            let imageUrl = "";
            if (state.textPost.thumbnail != null) { // there is a new thumbnail that needs to be uploaded
                if (payload.isDraft && (payload.draftPost.thumbnail != null && payload.draftPost.thumbnail != "") || payload.deleteDraftPostThumbnail) { // a thumbnail already exists on the draft post, delete it
                    await axios.delete(`thumbnails/${firebase.auth.currentUser.uid}/${payload.draftPost.postId}`).catch((error) => console.log("error deleting the thumbnail already associated with the post", error.message))
                }
                // imageUrl = await dispatch('uploadThumbnail');
                imageUrl = await dispatch('uploadTextThumbnail');
            } else if (state.textPost.thumbnail == null && payload.isDraft) { // it's a draft post and there is no new thumbnail to upload, use draft post thumbnail
                if (payload.deleteDraftPostThumbnail) { // is a youtube url and already had a thumbnail saved/associated with it but was removed to use default youtube thumbnail
                    await axios.delete(`thumbnails/${firebase.auth.currentUser.uid}/${payload.draftPost.postId}`).catch((error) => console.log("error deleting the thumbnail already associated with the post", error.message))
                } else {
                    imageUrl = payload.draftPost.thumbnail;
                }
            } // else, do nothing and image url will remain null

            let newTextPostRef = firebase.db.collection( state.isPublicPost ? "publicPosts" : "groupPosts").doc(state.textPost.postId);
            newTextPostRef.set({
                mediaType: "text",
                title: state.textPost.title,
                description: state.textPost.description,
                postDate: new Date(),
                postType: state.textPost.type,
                tags: state.textPost.tags,
                postId: state.textPost.postId,
                audioDataId: state.textPost.audioDataId,
                userId: state.textPost.userId,
                username: state.textPost.username,
                userProfilePhoto: state.textPost.userProfilePhoto,
                thumbnail: imageUrl, // ???
                randomThumbnailNumber: state.textPost.randomThumbnailNumber,
                languageName: state.textPost.languageSelected.text,
                textAddedLanguage: state.textPost.textAddedLanguageSelected,
                groupId: state.textPost.group ? state.textPost.group.groupId : null,
                groupName: state.textPost.group ? state.textPost.group.groupName : null,
                textAdded: state.textPost.textAdded,
                // canContribute: state.textPost.canContribute,
            }, {merge: true}).catch((err) => {
                console.error("Error saving the post metadata", err.message);
            })

            newTextPostRef.collection("contributions").doc(state.textPost.userId).set({
                audioDataId: audioDataIds,
            }, {merge: true}).catch((err) => {
                console.error("Error setting contributions for the post.", err.message);
            });
            state.postMetaDataUploadComplete = true;
            dispatch('setAudioCaptionAndTextData'); //dispatch('setTextData');
        },
        async simulateProgress ({commit, dispatch}, payload) {
            // console.log("simulateProgress: ", payload.progress);
            const { progress, interval } = payload;

            if (progress >= 100) return; // exit function when progress has reached 100

            let randomValue = Math.floor(Math.random() * (21 - 10) + 10); // get random value between 10 and 20 inclusive
            const newProgress = Math.min(progress + randomValue, 100); // make sure newProgress doesn't exceed 100
            commit('saveResumableProgress', newProgress); // update state value of resumable_progress to display to the user

            setTimeout(() => {
                const simulateProgressPayload = {
                    progress: newProgress,
                    interval: interval,
                };
                dispatch("simulateProgress", simulateProgressPayload); // recursively call simulateProgress with the new progress
            }, interval);
        },
        // async setTextData ({state, dispatch}) {
        //     state.audioCaptionsUploadComplete = false;
        //     // var textAdded = await dispatch('createTextObjects');
        //     var textAdded = await dispatch('setAudioCaptionAndTextData');

        //     if (textAdded.length === 0) {
        //         console.log("audo.length is = 0");
        //         state.audioCaptionsUploadComplete = true;
        //         dispatch('processText');
        //         // state.setTimeoutForProcessing();
        //         return;
        //     }

        //     if (typeof state.textPost.audioDataId === 'undefined' || typeof state.textPost.userId === 'undefined') {
        //         console.log("either state.textPost.audioDataId or .userId is undefined");
        //         console.log("audioDataId: ", state.textPost.audioDataId);
        //         console.log("userId: ", state.textPost.userId);
        //     }

        //     var newAudioRef = firebase.db.collection("audioSegments").doc(state.textPost.audioDataId);
        //     newAudioRef.set({
        //         title: state.textPost.title,
        //         userId: state.textPost.userId,
        //         username: state.textPost.username,
        //         userProfilePhoto: state.textPost.userProfilePhoto,
        //         postId: state.textPost.postId,
        //         text: textAdded,
        //         date: state.textPost.date,
        //         languageSelected: state.textPost.languageSelected,
        //         audioDataId: state.textPost.audioDataId,
        //     },{ merge: true });
        //     state.audioCaptionsUploadComplete = true;
        //     dispatch('processText'); // because setAudioCaptionData is called last, it should be the last thing to finish
        // },
        createTextObjects ({state}) {
             // state creates metadata for the actual audio file. state is not creating
            // the audio file itself.
            return new Promise ((resolve) => { // add a reject for a fail case???
                var objects = [];
                // console.log(state.textAdded);
                state.textAdded.forEach((text) => {
                    var object = {
                        text: text.text,
                        date: text.date,
                        languageSelected: text.languageSelected,
                        recordingTime: text.recordingTime,
                        audioURL: text.audioURL,
                        segment: text.segment,
                        caption: text.caption,
                        rect: text.rect,
                        style: text.style,
                    };
                    objects.push(object);
                });
                resolve(objects);
            });
            // return new Promise((resolve) => {
            //     var objects = [];
            //     state.audioCaptionData.audio.forEach((audio) => {
            //         var newObj = {
            //         audioURL: audio.audioURL,
            //         audioStart: audio.audioStart,
            //         audioDur: audio.audioDur,
            //         segment: audio.segment,
            //         };
            //         objects.push(newObj);
            //     });
            //     resolve(objects);
            // });
            
        },

        // ***
        // ADDED -- FEBRUARY 27, 2025 -- by Scott Brady, potentially needed to save the audio, caption and text data
        // Remove this comment if this code is needed
        // ***
        async setAudioCaptionAndTextData ({state, dispatch}) {
            const { audio, captions, text } = await dispatch('createAudioCaptionTextObjects');

            if (audio.length === 0) { // this should never happen because we require a user to add at least one audio/caption while creating
                state.audioCaptionsUploadComplete = true;
                dispatch('processText');
                return;
            }

            await firebase.db.collection("audioSegments").doc(state.textPost.audioDataId).set({
                noCaptionLanguageSelected: state.textPost.noCaptionLanguageSelected,
                languageName: state.textPost.languageSelected.text,
                languageCode: state.textPost.languageSelected.value,
                title: state.textPost.title,
                userId: state.textPost.userId, //firebase.auth.currentUser.uid,
                username: state.textPost.username,
                userProfilePhoto: state.textPost.userProfilePhoto, //firebase.auth.currentUser.photoURL,
                postId: state.textPost.postId,
                audio: audio,
                subtitles: captions,
                text: text,
                date: new Date(),
            }, { merge: true });

            state.audioCaptionsUploadComplete = true;
            dispatch('processText'); // because setAudioCaptionData is called last, it should be the last thing to finish
        },
        // bubbleSortByAudioStartTime({state}){
        //     return new Promise((resolve) => {
        //         const data = Object.values(state.tawqData).map((x, index) => {
        //             const audioObj = typeof x.audio !== 'undefined' ? x.audio : {
        //                 audioURL: null,
        //                 audioStart: null,
        //                 audioDur: null,
        //                 segment: index + 1,
        //             };

        //             const captionObj = {
        //                 subtitle: typeof x.caption !== 'undefined' ? x.caption : "",
        //                 audioSegId: index + 1,
        //             };

        //             return { audio: audioObj, caption: captionObj };
        //         });

        //         data.sort((a, b) => a.audio.audioStart - b.audio.audioStart); // Sort the data array based on audioStart property

        //         const sortedAudio = data.map(obj => obj.audio);
        //         const sortedCaptions = data.map(obj => obj.caption);

        //         resolve({ audio: sortedAudio, captions: sortedCaptions });
        //     });
        // },
        createAudioCaptionTextObjects ({state}) {
            return new Promise((resolve) => {
                const data = Object.values(state.tawqData).map((x, index) => {
                    const audioObj = typeof x.audio !== 'undefined' ? x.audio : {
                        audioDur: null,
                        audioEnd: null,
                        audioStart: null,
                        audioURL: null,
                        error: false,
                        segment: index + 1,
                    };

                    const captionObj = {
                        subtitle: typeof x.caption !== 'undefined' ? x.caption : "",
                        audioSegId: index + 1,
                    };

                    const textObj = typeof x.textAdded !== 'undefined' ? x.textAdded : {
                        audioDur: null,
                        audioURL: null,
                        segment: null,
                        subtitle: "",
                        text: "",
                        textCardIndexAssociationValue: null,
                    };

                    return { audio: audioObj, caption: captionObj, text: textObj };
                });

                data.sort((a, b) => a.text.textCardIndexAssociationValue - b.text.textCardIndexAssociationValue);

                const sortedAudio = data.map(obj => obj.audio);
                const sortedCaptions = data.map(obj => obj.caption);
                const sortedText = data.map(obj => obj.text);

                resolve({ audio: sortedAudio, captions: sortedCaptions, text: sortedText });
            });
        },
        // ***
        // 
        // ***

        // async uploadTextThumbnail ({state}) {
        //     // get the thumbnail from the file input
        //     var data = new FormData();
        //     data.append("file", state.textPost.thumbnail);
        //     data.append("postId", state.textPost.postId);
        //     data.append("mediaType", true);
        //     let response = await axios.post(`uploadpic`, data);
        //     return response.data.url;
        // },
        async uploadTextThumbnail({state}){
            const formData = new FormData();
            formData.append("file", state.textPost.thumbnail);
            formData.append("postId", state.textPost.postId);
            try {
                const response = await axios.post("/uploadpic", formData, {
                    headers: {
                        "Content-Type": "multipart/form-data"
                    }
                });
                // console.log("Thumbnail uploaded successfully:", response.data);
                return response.data.url;
            } catch (error) {
                console.error("Error uploading thumbnail:", error);
                return null;
            }
        },
        processText ({state, dispatch}) {
            /* state function will be called when PostUploadComplete = true, unless the image hasn't been resized yet,
            in which case it will be called once the image is done being resized */
            if (state.audioCaptionsUploadComplete && state.postMetaDataUploadComplete && state.textFileUploadComplete) {
                setTimeout(() => {
                    dispatch('resetStoreState');
                  }, 5000);
            } else {
                console.error("Processing didn't work, if this is the first time, we will try again.");
                if ( state.processTextAttempts > 0 ) { // if we have tried processing already
                    dispatch('deleteIncompletePostAudioFilesFromStorage');
                }
            }
            state.processTextAttempts += 1;
        },
        updateTextAdded ({commit}, data) {
            commit('saveTextAdded', data);
        },
        deleteIncompletePostAudioFilesFromStorage ({state}) {
            let audioDataRef = firebase.storage.ref(`audioSegments/${state.textPost.postId}/${state.textPost.audioDataId}`);
              audioDataRef.list().then((res) => {
                res.items.forEach(function (itemRef) {
                  /* retrieve the file names of each segment, so that we can delete each file
                    individually from the storage bucket. GCS doesn't allow us to delete the full bucket */
        
                  let filename = itemRef.name;
                  let audioRef = audioDataRef.child(filename);
                  audioRef.delete().then(() => {
                      return;
                    }).catch((error) => {
                      console.error(`Error Deleting Audio Segment File ${filename} from Storage:`, error);
                      return;
                    });
                });
            });
        },
        async deleteIncompletePostAudioFiles({dispatch}, payload){ // below will delete the audioFiles for an incomplete post
            // console.log("deleteIncompletePostAudioFiles called in NewTextPost.js");
            let audioDataRef = firebase.storage.ref(`audioSegments/${payload.postId}/${payload.audioDataId}`);

            let audioDataResponse = await audioDataRef.list(); // return a list of files (items) in the storage reference
            for (const itemRef of audioDataResponse.items) await audioDataRef.child(itemRef.name).delete(); // loops through each file (item) and deletes it
            // console.log("DONE deleteIncompletePostAudioFiles");
            dispatch('resetStoreState'); // reset the store state to default values
        },
        resetStoreState({commit}){
            /* this method will reset the data being stored for newPost */
            commit('resetStoreState');
        }
    }, // END Actions
    getters: {
        getOverlappingSegsForAudioSeg: (state) => (audioSegId) => {
            let overlappingSegs = [];
            const textSeg = state.tawqData[audioSegId]?.textSeg; // guard the card's own entry once — dereferencing it inside the loop threw a TypeError when absent
            if (!textSeg) return overlappingSegs;
            for (const key in state.tawqData) {
                if (typeof state.tawqData[key].textSeg === 'undefined' || state.tawqData[key].textSeg === null) {
                    continue; // skip entries without textSeg; returning here aborted the scan and hid overlaps in the rest of the list
                }
                if ((textSeg.segment != state.tawqData[key].textSeg.segment) && (textSeg.textCardIndexAssociationValue === state.tawqData[key].textSeg.textCardIndexAssociationValue)) {
                    overlappingSegs.push( parseInt(key) ); // this will add the INDEX number that the segment is overlapping
                }
            }
            return overlappingSegs;
        },
    },
} // END newTextPostStore

export default newTextPostStore